import React, { FC, useState, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import LoadMoreReviews from 'components/load-more-reviews'

import Review from '../review'

import { Center, Section } from '../styled'

import {
  ReviewsListHeader,
  SectionTitle,
  SortSelect,
  Collection
} from './styled'

interface PageContext {
    pageReviews: readonly Testimonial[]
    currentPage: number
    reviewsPerPage: number
    countPages: number
}

interface TestimonialEdge {
  node: Testimonial
}

type Props = {
  currentTestimonialsEdges: any
  setCurrentTestimonialsEdges: any
}

const ReviewsListSection: FC<Props> = ({ currentTestimonialsEdges, setCurrentTestimonialsEdges }) => {
  // Paging configuration
  const REVIEWS_PER_PAGE = 5
  const [pageContext, setPageContext] = useState<PageContext>(
    {
      pageReviews: currentTestimonialsEdges,
      currentPage: 1,  // Not zero-indexed
      reviewsPerPage: REVIEWS_PER_PAGE,
      countPages: Math.ceil(currentTestimonialsEdges.length / REVIEWS_PER_PAGE)
    }
  )
  // END Paging configuration

  // Sorting configuration
  const availableSorts = [
    {value: 'highest_rated', label: 'Highest rated'},
    {value: 'most_recent', label: 'Most recent'}
  ]
  const sortByHighestRated = (a: TestimonialEdge, b: TestimonialEdge) => (b.node.score > a.node.score) ? 1 : ((a.node.score > b.node.score) ? -1 : 0)
  const sortByMostRecent = (a: TestimonialEdge, b: TestimonialEdge) => (b.node.date > a.node.date) ? 1 : ((a.node.date > b.node.date) ? -1 : 0)

  const [currentSort, setCurrentSort] = useState<string>('highest_rated')
  useEffect(() => {
    const sortReviewsList = (sortType: string) => {
      const sorted = sortType === 'highest_rated' ?
        [...currentTestimonialsEdges].sort(sortByHighestRated) :
        [...currentTestimonialsEdges].sort(sortByMostRecent)
      setCurrentTestimonialsEdges(sorted)
      setPageContext(
        (oldPageContext: PageContext) => ({...oldPageContext, pageReviews: sorted})
      )
    }

    sortReviewsList(currentSort)
  }, [currentSort])  // eslint-disable-line
  // ESLint will add deps to useEffect that cause an infinite loop
  // END Sorting configuration

  // Event handler for dropdown
  const handleChange = (e: any) => {
    setCurrentSort(e.value)
  }

  return (
    <Section>
    	<Center>
        <ReviewsListHeader>
  	      <SectionTitle>
  		      All reviews
  	      </SectionTitle>
          <SortSelect
            id="sort-select"
            name="reviews-list-sort"
            label="Sort"
            options={availableSorts}
            value={availableSorts.find((sort) => sort.value === currentSort)}
            onChange={handleChange}
          />
        </ReviewsListHeader>
        <LoadMoreReviews
          pageContext={pageContext}
          setPageContext={setPageContext}
          renderItem={(testimonialEdge: TestimonialEdge) => <Review testimonialEdge={testimonialEdge} key={testimonialEdge.node.id} />}
          WrapperComponent={Collection}
          noContentMessage="There are no reviews yet."
        />
      </Center>
    </Section>
  )
}

export default ReviewsListSection
